module.exports = "./img/desktop_logo.7e9416a.png";